import React from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import { TableColumnDef } from "../../components/DataTable";
import { createSanitizedMarkup } from "../../utils/createSanitizedMarkup";
import type { ContentLanguage } from "../../hooks/useContentLanguage";

type ColumnActions = {
  canEdit: boolean;
  canDelete: boolean;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
  lang: ContentLanguage;
};

export const buildWarningColumns = ({
  canEdit,
  canDelete,
  onEdit,
  onDelete,
  lang,
}: ColumnActions): TableColumnDef[] => [
  {
    header: "Bezeichnung",
    render: (row: any) => (lang === "de" ? row?.warningName_ger : row?.warningName) || "-",
    getValue: (row: any) => lang === "de" ? row?.warningName_ger : row?.warningName,
  },
  {
    header: "Warndetails",
    render: (row: any) => (
      <Box
        className="showmore-class"
        dangerouslySetInnerHTML={createSanitizedMarkup({
          html: lang === "de" ? row?.warningDetails_ger : row?.warningDetails,
        })}
      />
    ),
  },
  {
    header: "Datum",
    render: (row: any) => moment(row?.date).format("DD.MM.YYYY"),
    getValue: (row: any) => row?.date,
  },
  {
    header: "Zeit",
    render: (row: any) => moment(row?.date).format("HH:mm"),
    getValue: (row: any) => row?.date,
  },
  {
    header: "Einstellungen",
    render: (row: any) => (
      <Box sx={{ display: "flex", gap: 0.5 }}>
        {canEdit && (
          <Tooltip title="Warnung bearbeiten" arrow>
            <IconButton size="small" color="primary" onClick={() => onEdit(row)}>
              <CreateIcon />
            </IconButton>
          </Tooltip>
        )}
        {canDelete && (
          <Tooltip title="Warnung l&ouml;schen" arrow>
            <IconButton size="small" color="error" onClick={() => onDelete(row)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    ),
  },
];
